import React, { useState } from "react";
import styles from "./Input.module.scss";
import { ErrorIcon } from "../../../../assets/icons/ErrorIcon";

export const Input = ({
  label,
  smallText,
  value,
  onChange,
  placeholder,
  useTime = false,
  labelStyle,
  errorText,
  type = "text",
  ...props
}) => {
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    let inputValue = e.target.value;

    // Если используется маска времени
    if (useTime) {
      // Убираем все, что не является цифрой или двоеточием
      inputValue = inputValue.replace(/[^0-9:]/g, "");

      // Применяем маску 00:00:00
      if (inputValue.length > 8) {
        inputValue = inputValue.slice(0, 8);
      }
      if (inputValue.length > 2 && inputValue[2] !== ":") {
        inputValue = inputValue.slice(0, 2) + ":" + inputValue.slice(2);
      }
      if (inputValue.length > 5 && inputValue[5] !== ":") {
        inputValue = inputValue.slice(0, 5) + ":" + inputValue.slice(5);
      }

      // Проверка на правильность формата времени
      if (
        inputValue.length > 0 &&
        !/^([0-1]?[0-9]|2[0-3]):([0-5]?[0-9]):([0-5]?[0-9])$/.test(inputValue)
      ) {
        setError("Не верный формат - 00:00:00");
      } else {
        setError(null);
      }
    } else {
      setError(null);
    }

    // Вызываем функцию обратного вызова с новым значением
    onChange(inputValue);
  };

  return (
    <div className={styles.inputContainer}>
      {label && (
        <label className={`${styles.label} ${labelStyle} `}>
          {label}{" "}
          {error && <small className={styles.errorText}>({error})</small>}
        </label>
      )}
      <input
        className={`${styles.input} ${error ? styles.error : ""} ${
          errorText ? styles.error : ""
        }`}
        type={type}
        value={value || ""}
        onChange={handleChange}
        placeholder={placeholder}
        {...props}
      />

      {errorText && (
        <div className={styles.errorContainer}>
          <ErrorIcon size={12} fill={"#EF4444"} />
          <small className={styles.errorText}>{errorText}</small>
        </div>
      )}

      {smallText && !errorText && (
        <small className={styles.smallText}>{smallText}</small>
      )}
    </div>
  );
};
